<!-- eslint-disable max-len -->
<template>
  <div class="license-con">
    <div class="layout-license">
      <h1 class="license-title">飞布智慧物流平台-隐私政策（承运商）</h1>
      <ol class="license-list">
        <li>
          请您在开始使用我们的产品“飞布智慧物流平台”（以下简称"本平台"）之前请务必仔细阅读并理解《隐私政策》（以下简称"本政策"）。
        </li>
        <li>本隐私政策发布日期：【 2021 】年【 11 】月【 30 】日</li>
        <li>本隐私政策生效日期：【 2021 】年【 11 】月【 30 】日</li>
      </ol>

      <p class="license-item-title">1. 前言</p>
      <ol class="license-list">
        <li>
          广州市布掌柜信息科技有限公司（以下统称"布掌柜公司"、“布掌柜”或"我们"）庄严承诺保护使用本平台的产品和服务之用户（以下统称 "用户"或"您"）的个人信息和隐私安全。布掌柜公司尊重并保护所有使用服务用户的个人隐私权。为了给您提供更准确、更有个性化的服务，布掌柜公司会按照本隐私政策的规定使用和披露您的个人信息。您在使用本平台服务时，我们可能会收集和使用您的相关个人信息。<span class="weight-bold">我们希望通过本政策向您说明我们在收集和使用您相关个人信息时对应的处理规则等相关事宜，以便更好地保障您的权益。</span>但布掌柜公司将以高度的勤勉、审慎义务对待这些信息。除本隐私权政策另有规定外，在未征得您事先许可的情况下，布掌柜公司不会将这些信息对外披露或向第三方提供。布掌柜公司会不时更新本隐私权政策。<span class="weight-bold">您在同意布掌柜公司隐私政策之时，即视为您已经同意本隐私权政策全部内容，若您不同意本隐私政策，您将无法继续使用本平台。</span>本隐私权政策属于布掌柜公司服务使用协议不可分割的一部分。
        </li>
      </ol>

      <p class="license-item-title">2. 法律声明 </p>
      <p class="license-item">一、 权利归属</p>
      <ol class="license-list">
        <li>
          <div>
            本平台的Logo、"飞布达"、“飞布智慧物流平台”、“飞布小程序”等文字、图形及其组合，以及本平台其他标识、徽记、服务名称等为广州市布掌柜信息科技有限公司或其关联公司的商标和/或拥有著作权的作品。未经我们书面授权，任何人不得以任何方式展示、使用本平台图文或对本平台图文做其他处理(包括但不限于复制、传播、展示、镜像、上传、下载)，也不得向他人表明您有权展示、使用本平台图文或对本平台图文做其他处理。
          </div>
          <div>
            本平台所有的产品、软件、服务、技术与所有应用程序或其组件/功能(以下或简称"技术服务")的知识产权均归属于广州市布掌柜信息科技有限公司或其关联公司所有。除非另行声明，广州市布掌柜信息科技有限公司拥有其在网站内发布的文档等信息(包括但不限于文字、图形、图片、照片、音频、视频、图标、色彩、版面设计、电子文档)的所有权利(包括但不限于版权、商标权、专利权、商业秘密和其他所有相关权利)。未经本平台许可，任何人不得擅自使用如上内容(包括但不限于通过程序或设备监视、复制、转播、展示、镜像、上传或下载)。被授权浏览、复制、打印和传播属于本平台产品及服务内信息内容的，该内容都不得用于商业目的且所有信息内容及其任何部分的使用都必须包括此权利声明。
          </div>
        </li>
      </ol>
      <p class="license-item">二、 责任限制</p>
      <ol class="license-list">
        <li>
          本平台用户在本平台产品中上传、提供及储存的相关信息均由用户自行提供，本平台用户须对任何该等信息承担全部责任(包括但不限于对该等信息的真实性及合法性所应承担的责任)，广州市布掌柜信息科技有限公司或其关联公司对其均不承担任何责任。<span class="weight-bold">我们在此提示，您在使用本平台产品及服务期间应当遵守中华人民共和国的法律，不得危害网络安全，不得利用本平台产品及服务从事侵犯他人名誉、隐私、知识产权和其他合法权益的活动。尽管有前述提示，我们不对您使用本平台产品及服务的用途和目的承担任何责任。</span>
        </li>
      </ol>

      <p class="license-item-title">3. 隐私条款</p>
      <ol class="license-list">
        <li>
          本隐私条款部分将帮助您了解以下内容:
        </li>
        <li>
          一、我们如何收集和使用您的信息
        </li>
        <li>
          二、我们如何使用 Cookie 和同类技术
        </li>
        <li>
          三、我们如何存储您的信息
        </li>
        <li>
          四、我们如何共享、转让、披露您的信息
        </li>
        <li>
          五、如何访问和管理您的信息
        </li>
        <li>
          六、我们如何保护您的信息
        </li>
        <li>
          七、未成年人保护
        </li>
        <li>
          八、本隐私条款如何更新
        </li>
        <li>
          九、如何联系我们
        </li>
        <li>
          十、其他
        </li>
      </ol>

      <p class="license-item">一、我们如何收集和使用您的信息 </p>
      <ol class="license-list">
        <li>
          (一)我们如何收集您的信息以及我们可能收集的您的信息范围
        </li>
        <li>
          我们会出于本条款所述的以下目的，自行或通过关联公司收集和使用您的如下信息:
          <div>
            1. 当您注册成为本平台用户，以便我们为您提供用户服务。您需要提供您的<span class="weight-bold">手机号码</span>，并创建本平台账号和密码。收集这些信息是为了帮助您完成本平台用户的注册，保护您的账号安全。手机号码属于敏感信息，，并创建本平台账号和密码。收集这些信息是为了帮助您完成本平台用户的注册，保护您的账号安全。手机号码属于敏感信息，收集此类信息是为了满足相关法律、法规关于网络实名制要求。若您不提供这类信息，您可能无法正常使用我们的服务。您还可以根据自身需求填写<span class="weight-bold">姓名、性别、职业、公司名称、公司座机、收货地址</span>信息。
          </div>
          <div>
            2. 当您使用布掌柜公司平台服务时，为保障您正常使用我们的服务，维护我们服务的正常运行，改进及优化我们的服务体验以及保障您的账号安全，我们会收集您的<span class="weight-bold">设备型号、操作系统、设备Mac地址、唯一设备标识符、登录IP地址、网络质量数据、操作日志、服务日志信息</span>。
          </div>
          <div>
            3. 当您使用布掌柜公司APP搜索或浏览运单、商品内容时，我们会收集您的<span class="weight-bold">搜索记录、浏览记录、访问时间、互动记录</span>，目的是向你提供更加精准和个性化的服务和内容。
          </div>
          <div>
            4. 当您使用布掌柜公司APP的相关付费服务时，我们将收集您的<span class="weight-bold">运单信息</span>，因为这是为您提供服务所必须的基础信息。
          </div>
          <div>
            5. 根据相关法律法规及国家标准，在以下情况中，我们会收集、使用您的个人信息，而无需征求您的同意：
            <div>
              5.1. 与国家安全、国防安全等国家利益直接相关的，和/或与公共安全、公共卫生、公众知情等重大公共利益直接相关的；
            </div>
            <div>
              5.2. 与犯罪侦查、起诉、审批和判决执行等直接相关的；
            </div>
            <div>
              5.3. 出于维护您或者其他个人的生命、财产、声誉等重大合法权益的目的，但难以得到本人同意的；
            </div>
            <div>
              5.4. 根据您的要求签订和履行合同所必需的；
            </div>
            <div>
              5.5. 用于维护布掌柜所提供的产品或者服务的安全稳定运行所必需的，例如：发现、处置产品或者服务的故障；
            </div>
            <div>
              5.6. 为开展合法的新闻报道所必需的；
            </div>
            <div>
              5.7. 法律法规规定的其他情形。
            </div>
          </div>
          <div>
            6.向您提供产品或服务
            <div>
              1) 您向我们提供的信息在服务使用过程中，您可以对本平台产品及服务的体验问题反馈，帮助我们更好地了解您使用我们产品或服务的体验和需求，改善我们产品或服务。
            </div>
            <div>
              2) 我们在您使用服务过程中收集的信息，为向您提供更好、更个性化的服务，例如在不同的服务端或设备上提供更个性化但体验一致的服务，更契合您需求的输入推荐、客服接待或信息推送，了解产品适配性，识别账号异常状态，我们会收集您使用服务的相关信息，这些信息包括:<span class="weight-bold">设备信息、日志、服务使用信息</span>。
              <div>
                A. 设备信息: 我们可能会收集您<span class="weight-bold">设备或软件专用的信息(即您的硬件型号、操作系统版本、唯一设备标识符以及包括电话号码在内的移动网络信息)</span>。我们可 能会将您的设备标识符或电话号码与您的账户相关联。
              </div>
              <div>
                B. 日志信息:当您使用我们的网站或客户端提供的产品或服务时，我们会自动收集您对我们服务的详细使用情况，作为有关网络日志保存。例如您的<span class="weight-bold">搜索查询内容、IP 地址、浏览器的类型、电信运营商、使用的语言、访问日期和时间、您访问的网页记录</span>。
                请注意，单独的设备信息、日志信息等是无法识别特定自然人身份的信息。如果我们将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息，除取得您授权或法律法规另有规定外，我们会将该类个人信息做匿名化、去标识化处理。
              </div>
              <div>
                C. 服务使用信息: 我们会记录您在<span class="weight-bold">使用本平台产品及服务时提交或产生的信息、上传的附件和图片文件</span>。当您在使用本平台产品及服务执行某些操作时(例如新建运单)，我们可能会向您或其他方发送通知。对于您在本平台开通使用的第三方应用服务，我们将在您启动该应用时收集相关信息，并按照本条款进行处理;第三方应用服务提供者可能会获取您使用本平台服务的相关信息，该第三方应用服务对您的信息的收集(如有)则受该第三方隐私权条款约束。
              </div>
              <div>
                D. 其他信息: 为展示您账号的运单信息，我们会收集您在使用我们服务过程中产生的运单信息用于向您展示及便于您对运单进行管理。 当您与我们联系时，我们可能会保存您的<span class="weight-bold">通信/通话记录和内容</span>或<span class="weight-bold">您留下的联系方式</span>信息，以便与您联系或帮助您解决问题，或记录相关问题的处理方案及结果。
              </div>
            </div>
            <div>
              3） 第三方向我们提供的信息本平台将可能在其他用户进行与您相关的操作时收集关于您的信息，亦可能从本平台关联公司、合作第三方或通过其他合法途径获取的您的相关数据信息。
            </div>
            <div>
              4）我们的产品集成友盟+SDK，友盟+SDK需要收集您的设备Mac地址、唯一设备识别码（IMEI/android ID/IDFA/OPENUDID/GUID/IP地址/SIM 卡 IMSI 信息）以提供统计分析服务，并通过地理位置校准报表数据准确性，提供基础反作弊能力。 友盟+SDK隐私政策链接如下：https://www.umeng.com/page/policy。
            </div>
          </div>
          <div>
            7.为您提供安全保障
            <div>
              为预防、发现、调查欺诈、侵权、危害安全、非法或违反与我们或与我们关联公司的协议、条款或规则的行为，我们可能收集或整合您的<span class="weight-bold">用户信息、服务使用信息、设备信息、日志信息</span>以及我们关联公司、合作伙伴取得您授权或依据法律共享的信息。
            </div>
          </div>
          <div>
            8.其他用途
            <div>
              我们基于本条款未载明的其他特定目的收集您的信息时，会事先征求您的同意。我们收集及使用上述信息的目的是为了更好地经营本平台产品和服务(包括但不限于向您提供个性化的服务)， 并且会通过包括但不限于通过网站通知、电子邮件、电话或短信息等方式通知。 如我们停止运营本平台产品及服务，我们将及时停止继续收集您的相关信息的活动，并将停止运营的通知以逐一送达或公告的形式通知您，对所持有的您的信息进行删除或匿名化处理。
            </div>
          </div>
        </li>
        <li>
          （二）我们如何使用您的信息
          <div>
            收集您的信息是为了向您提供服务及提升服务质量，为了实现这一目的，我们会把我们于本条款项下所收集、取得及存储的您的信息用于下列用途:
          </div>
          <div>
            1. 向您提供您使用的本平台产品及服务，并维护、改进、优化这些服务及服务体验，并开发新的功能以向您提供更好的服务;
          </div>
          <div>
            2. 为预防、发现、调查欺诈、侵权、危害安全、非法或违反与我们或与我们关联公司的协议、条款或规则的行为，保护您、其他用户或公众，我们或我们关联公司的合法权益，我们可能使用或整合您的用户信息、服务使用信息、设备信息、日志信息以及我们关联公司、合作伙伴取得您授权或依据法律共享的信息，来综合判断您账户及交易风险、进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施;
          </div>
          <div>
            3. 我们可能将通过某些功能收集的信息用于我们的其他服务。为了让您有更好的体验、改善我们的服务或您同意的其他用途，在符合相关法律法规的前提下，我们可能将通过某一项服务所收集的信息，以汇集信息或者个性化的方式，用于我们的其他服务。例如，在您使用我们的一项服务时所收集的信息，可能在另一服务中用于向您提供特定内容，或向您展示与您相关的、非普遍推送的信息。如果我们在相关服务中提供了相应选项，您也可以授权我们将该服务所提供和储存的信息用于我们的其他服务。
          </div>
          <div>
            4. 告知变动目的后征得同意的方式
            我们将会在本隐私保护指引所涵盖的用途内使用收集的信息。如我们使用您的个人信息，超出了与收集时所声称的目的及具有直接或合理关联的范围，我们将在使用您的个人信息前，再次向您告知并征得您的明示同意。
          </div>
        </li>
      </ol>

      <p class="license-item">二、 我们如何使用 Cookie 和同类技术</p>
      <ol class="license-list">
        <li>
          为使您获得更轻松的访问体验，您使用本平台产品及服务时，我们可能会通过采用各种技术收集和存储您访问本平台产品及服务的相关数据，在您访问 或再次访问本平台产品及服务时，我们能识别您的身份，并通过分析数据为您提供更好更多的服务。包括使用小型数据文件识别您的身份，这么做是为了解您的使用习惯，帮您省去重复输入账户信息的步骤，或者帮助判断您的账户安全。这些数据文件可能是Cookie、FlashCookie， 或您的浏览器或关联应用程序提供的其他本地存储(统称"Cookie" )。请您理解，我们的某些服务只能通过使用 Cookie 才可得到实现。如果您的浏览器或浏览器附加服务允许，您可以修改对 Cookie 的接受程度或者拒绝本平台的 Cookie，但拒绝本平台的 Cookie 在某些情况下您可能无法使用依赖于 cookies 的本平台服务的部分功能。网页上常会包含一些电子图像，称为"单像素 GIF 文件"或"网络 beacon"，它可以帮助网站计算浏览网页的用户或访问某些 cookie。我们会通过网络beacon 收集您浏览网页活动信息，例如您访问的<span class="weight-bold">页面地址</span>、您先前访问的<span class="weight-bold">援引页面的地址</span>、您<span class="weight-bold">停留在页面的时间</span>、您的<span class="weight-bold">浏览环境</span>以及<span class="weight-bold">显示设定</span>。
        </li>
      </ol>

      <p class="license-item">三、我们如何存储您的信息</p>
      <ol class="license-list">
        <li>我们将通过如下方式存储我们于本条款项下收集或取得的您的信息: </li>
        <li>
          （一）本地存储
          <div>
            我们可能会使用浏览器网络存储等机制(包括 HTML5)和应用数据缓存等途径，收集您设备上的信息以及您在使用我们产品或服务时向我们提供的信息，并进行本地存储。
          </div>
        </li>
        <li>
          （二）Cookie 和匿名标识符
          <div>
            如本条款前文所述，当您使用本平台产品及服务时，我们可能会通过采用Cookie 或网络 beacon 等技术手段收集和存储您访问本平台产品及服务的相关数据。
          </div>
        </li>

        <li>
          （三）文件存储
          <div>
            我们会存储由您上传至服务器上的附件(包括但不限于 pdf、word、excel 等格式)、产品图片、打印模板文件。在保证您的信息安全的前提下，你理解并同意我们通过云服务对您的信息按照本条款约定的条件进行收集、使用、储存和共享。
          </div>
        </li>
      </ol>

      <p class="license-item">四、我们如何共享、转让、披露您的信息</p>
      <ol class="license-list">
        <li>
          您知晓并同意，在以下情形下，我们以及我们的关联公司可能会共享、转让或披露您的信息:
        </li>
        <li>
          1. 我们以及我们的关联公司，可能将您的信息共享并用于下列用途:
          <div>
            （1）与运输需求客户共享:我们可能会与具有运输需求的客户共享您的某些信息，以提供更好的客户服务和用户体验，例如，在您通过本平台使用物流提供服务时，我们必须与客户共享您的信息（<span class="weight-bold">名字、联系电话、车牌号</span>）以便接收货物、查看行程等数据才能安排送货;
          </div>
          <div>
            （2）实现本条款第3部分（“隐私政策”）第一项("我们如何收集和使用您的信息")所述之目的;
          </div>
          <div>
            （3）履行我们在本条款中的义务及行使我们在本条款项下的权利;
          </div>
          <div>
            （4）在您被他人投诉侵犯知识产权或其他合法权利时，需要向投诉人披露您的必要资料，以便进行投诉处理的;
          </div>
        </li>
        <li>
          2.在不透露单个用户隐私信息的前提下，我们及我们委托的关联公司及(或)有权对整个用户数据库进行推演、计算、分析、梳理、挖掘应用，并在此基础上对用户数据库进行商业上的利用。我们保证不会在未经相关用户同意的前提下对外公开或向第三方提供单个用户的注册资料及用户在使用服务时存储在我们处或提供予我们的非公开内容。
        </li>
        <li>
          3. 在我们或我们的关联公司发生合并、收购、资产转让或类似交易或破产清算情形时，您的信息有可能作为此类交易或程序的一部分而被转移。我们将在转移前提前通知您，并会要求新的接收您的信息的主体继续受本条款的约束，否则我们将要求该等主体重新向您征求授权同意。
        </li>
        <li>
          4. 经您事先明确同意，我们可能与我们的关联公司、合作伙伴及/或第三方共享、转让或披露您的信息。我们仅会出于合法、正当、必要、特定、明确的目的共享您的信息，并且只会共享提供相关服务所必要的信息。我们的合作伙伴无权将共享的信息用于与产品或服务无关的其他用途。
        </li>
        <li>
          本平台产品可能含有到其他网站的链接。除法律另有规定外，本平台对其他网站的隐私保护措施不负任何责任。我们可能在任何需要的时候增加商业伙伴或共用品牌的网站，但是提供给他们的将仅是综合信息，我们将不会公开可用于识别您的身份的信息。
        </li>
      </ol>

      <p class="license-item">五、如何访问和管理您的信息</p>
      <ol class="license-list">
        <li>
          （一）信息删除
          <div>在以下情况下，应您的请求，我们会删除您的信息，或按照适用的相关法律、法规及标准匿名化处理您的信息: </div>
          <div>1. 您主动注销账号; </div>
          <div>2. 您以书面通知的形式明确表示您不同意接受本条款;  </div>
          <div>3. 您要求我们删除您的信息; </div>
          <div>4. 如果我们终止服务及运营; </div>
          <div>5. 相关法律法规及国家标准的规定，或依据政府部门、司法机关的要求必须予以删除，或您的信息存储期限到期。 </div>
        </li>
        <li>
          （二）您的权利
          <div>按照适用的相关法律、法规及标准，我们保障您对自己的信息行使以下权利:</div>
          <div>
            1. 如您对本条款有任何疑问，您可随时按照本条款第3部分第九项（“如何联系我们”）的约定与我们联系。在核实您真实身份后，您可以查阅、要求更正或者删除您的信息。我们将在收到您请求后15个工作日内或法律法规规定的期限内给出答复及合理解释。
          </div>
          <div>
            2. 当您的信息被更正或删除后，我们将不再处理相应的信息。但不会影响此前基于您的授权而开展的信息处理。
          </div>
          <div>
            3. 如我们因法律法规的要求，或者受技术所限，无法满足您的所有要求，我们仍会在合理的期限内答复您的请求，并给出合理解释。
          </div>
        </li>
      </ol>

      <p class="license-item">六、我们如何保护您的信息</p>
      <ol class="license-list">
        <li>
          我们会采取各种预防措施来保护您的信息，以保障您的信息免遭丢失、盗用和误用，以及被擅自取阅、披露、更改或销毁。为确保您的信息的安全，我们有严格的信息安全规定和流程，并有专门的信息安全团队在公司内部严格执行上述措施。我们会建立专门的管理制度、流程和组织以保障信息的安全。例如，我们严格限制访问信息的人员范围，要求他们遵守保密义务，并进行审核。我们会制定与信息安全相关的网络安全事件应急预案，及时处置系统漏洞、计算机病毒、网络攻击、网络侵入等安全风险。在发生或者可能发生信息泄露、丢失的情况时，
          我们会:
        </li>
        <li>
          <div>
            （1）立即采取补救措施，按照规定及时告知用户并向有关主管部门报告;
          </div>
          <div>
            （2）立即启动网络安全事件应急预案，对网络安全事件进行调查和评估，采取技术措施和其他必要措施，消除安全隐患，防止危害扩大;
          </div>
          <div>
            （3）及时将事件相关情况以邮件、信函、电话、推送通知等方式告知受影响的信息主体。难以逐一告知信息主体时，我们采取合理、有效的方式发布与公众有关的警示信息。 我们会采取合理可行的措施，尽力避免收集无关的信息，并在限于达成本条款所述目的所需的期限内保留您的信息，除非需要延长保留期限或在法律的允许期限内。互联网环境并非百分之百安全，尽管我们有这些安全措施， 但请注意在互联网上不存在"完善的安全措施"，我们将尽力确保您的信息的安全性。
          </div>
        </li>
      </ol>

      <p class="license-item">七、未成年人保护</p>
      <ol class="license-list">
        <li>
          我们重视未成年人的信息保护，如您为未成年人的，建议您<span class="weight-bold">请您的父母或监护人仔细阅读本隐私权条款，并在征得您的父母或监护人同意的前提下使用我们的服务或向我们提供信息</span>。对于经父母或监护人同意使用我们的产品或服务而收集未成年人个人信息的情况，我们只会在法律法规允许，父母或监护人明确同意或者保护未成年人所必要的情况下使用，共享，转让或披露此信息。我们将根据国家相关法律法规及本条款的规定保护未成年人的个人信息。
        </li>
      </ol>

      <p class="license-item">八、本条款如何更新 </p>
      <ol class="license-list">
        <li>
          我们的隐私条款可能会不时更新，更新后的隐私政策一旦在本平台上公布即有效并代替原来的隐私政策，如您选择继续接受本平台提供的服务，则视为您已经接受本隐私政策更新的内容。未经您明确同意我们不会限制您按照本条款所应享有的权利。
        </li>
      </ol>

      <p class="license-item">九、如何联系我们 </p>
      <ol class="license-list">
        <li>
          如果您对我们的隐私保护条款或数据处理有任何疑问、意见或建议，可以通过我们提供的各种联系方式与我们联系。我们的联系方式如下:
        </li>
        <li>
          公司名称：广州市布掌柜信息科技有限公司
        </li>
        <li>
          公司地址：广东省广州市海珠区新滘西路533号鸿洲国际轻纺城首层B1036
        </li>
        <li>
          个人信息保护负责人及联系方式：020-32643353
        </li>
      </ol>

      <p class="license-item">十. 其他</p>
      <ol class="license-list">
        <li>
          本条款的成立、生效、履行、解释及纠纷解决，适用中华人民共和国法律。如就本条款的解释或执行发生争议，双方应首先力争通过友好协商解决该争议。如果在争议发生后六十日内未能通过协商解决，则任何一方均可向广州市布掌柜信息科技有限公司所在地的广州仲裁委员会提起仲裁解决。当任何争议发生时以及在对任何争议进行仲裁时，除争议事项外，双方应继续行使各自在本条款项下的其他权利，履行各自在本条款项下的其他义务。如果本条款中的任何条款因任何原因被判定为完全或部分无效或不具有执行力，本条款的其余条款仍应有 效并且具有执行力。如本条款中的任何条款与此前发布的历史版本隐私条款存在约定不一致或相互冲突的，以本条款的约定为准。
        </li>
      </ol>
    </div>

  </div>
</template>

<style scoped lang="scss">
  .license-con{
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    color: #000000;
    background: #F8F8F8;
    overflow-y: auto;
  }
  .layout-license {
    padding: 0 20px 20px 20px;
    font-size: 12px;
    background: #FFFFFF;
    margin: 15px;
    border: 1px solid #FFFFFF;
    box-shadow:0 8px 16px 0 rgba(0, 0, 0, 0.06);
    border-radius:8px;
  }
  .license-title {
    font-size:16px;
    font-weight:700;
    color:rgba(51,51,51,1);
    line-height:28px;
    margin: 25px 0;
    text-align: left;
  }
  .license-tips {
    margin-top: 20px;
    font-size: 12px
  }

  .license-item-title {
     margin: 20px 0 10px 0;
    font-size:15px;
    font-weight: 700;
    color:rgba(51,51,51,1);
    line-height:24px;
  }

  p.license-item {
    margin: 20px 0 10px 0;
    font-size:13px;
    font-weight:600;
    color:rgba(51,51,51,1);
    line-height:24px;
  }
  ol.license-list {
    list-style-type: none;
    margin: 0;
    padding: 0;
    color: #333333;
  }
  ol.license-list li {
    list-style-type: none;
    margin: 0;
    line-height: 24px;
    color: #333333;
  }
  .weight-bold {
    font-weight: bold;
  }
</style>
